<template>
  <ais-panel class="filter">
    <div
      class="filter-header"
      @click="toggle"
    >
      <div class="filter-title">
        <div class="filter-icon">
          <v-icon :path="icon" class="filter-image" alt="" />
        </div>
        <h4 class="filter-label">{{ displayName }} <strong
            class="ais-RefinementList-count"
            v-if="appliedRefinements"
          >{{ appliedRefinements }}</strong></h4>
      </div>
      <img
        class="filter-arrow"
        src="~@/assets/icons/caret.png"
        alt=""
        :class="{ 'filter-arrow-expanded': value }"
      />
    </div>

    <!-- filter on this type if it's open -->
    <type-filter
      :type="type"
      v-if="value"
    />

    <div
      slot="default"
      v-show="value && isCurrentlyRefined"
    >
      <slot />
    </div>
  </ais-panel>
</template>

<script>
import { createWidgetMixin } from 'vue-instantsearch';
import { createPanelProviderMixin } from '../mixins/panel';
import TypeFilter from './TypeFilter';
import VIcon from './VIcon';

export default {
  components: { TypeFilter, VIcon },
  mixins: [createPanelProviderMixin(), createWidgetMixin({ connector: true })],
  props: {
    displayName: String,
    icon: String,
    value: Boolean,
    type: String,
  },
  methods: {
    toggle() {
      this.$emit('input');
    },
  },
  computed: {
    isCurrentlyRefined() {
      const values =
        (this.instantSearchInstance.helper &&
          this.instantSearchInstance.helper.lastResults &&
          this.instantSearchInstance.helper.lastResults._state.facetsRefinements
            .type) ||
        [];
      return values.includes(this.type);
    },
  },
};
</script>

<style lang="scss" scoped>
.filter {
  &-header {
    $block: &;
    display: flex;
    padding: 10px 0;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
  }
  &-title {
    display: flex;
    align-items: center;
  }
  &-label {
    font-weight: 700;
  }
  &-icon {
    display: flex;
    width: 22px;
    height: 2em;
    flex-grow: 0;
    flex-shrink: 0;
    margin-right: 8px;
    align-items: center;
    justify-content: center;
  }
  &-image {
    display: block;
    max-width: 100%;
    max-height: 100%;
  }
  &-arrow {
    display: block;
    width: 7px;
    margin-left: 8px;
    transition: transform 0.2s ease-in-out;
    &-expanded {
      transform: rotateZ(90deg);
    }
  }
  /deep/ {
    .ais-RefinementList-count {
      margin-left: 8px;
      @include theme-value(color, brand-color-one);
      font-weight: 600;
      &::before {
        content: '(';
      }
      &::after {
        content: ')';
      }
    }
    .ais-RefinementList-list {
      margin: 8px 0;
    }
    .ais-RefinementList-item,
    .ais-RefinementList-noResults {
      padding: 6px 0;
      line-height: normal;
      .ais-RefinementList-label,
      label {
        display: flex;
        align-items: center;
        span {
          &:first-of-type {
            display: flex;
            align-items: center;
            cursor: pointer;
            &::before {
              display: block;
              width: 16px;
              height: 16px;
              margin-right: 14px;
              background: darken($alabaster-white, 10%);
              box-shadow: inset 0 0 0 2px $alabaster-white;
              border-radius: 100%;
              border: 1px solid $black;
              content: '';
              transition: background 0.2s;
              flex-grow: 0;
              flex-shrink: 0;

              .gourmet-society & {
                border-radius: 0;
              }
            }
          }
        }
        &:hover {
          span {
            &:first-of-type {
              &::before {
                background: darken($alabaster-white, 20%);
              }
            }
          }
          input[type='checkbox']:checked + span {
            &::before {
              @include theme-value(background, brand-color-one--dark);
            }
          }
        }
        input[type='checkbox']:checked + span {
          &::before {
            @include theme-value(background, brand-color-one);
          }
        }
      }
    }
    .ais-RefinementList-checkbox,
    input[type='checkbox'] {
      display: none;
    }
  }
}
</style>
